import useTranslation from 'hooks/useTranslation'
import React from 'react'
import './style.scss'

interface MagNumberProps {
  number: string | number
  isShared?: boolean
  isDesktop?: boolean
  acronym?: string
  isLight?: boolean
  rentableType?: warehouse.RentableType
}

const type = process.env.REACT_APP_TYPE

const MagNumber: React.FC<MagNumberProps> = ({ number, isLight, isShared, acronym, rentableType, isDesktop = false }) => {
  const { t } = useTranslation('basic')

  return (
    <div className={`mag__number ${isLight ? 'light' : ''}`}>
      <div className='mag__number__top'>
        {type === 'mm'
          ? <>
            <div className='mag__icon'>
              <i className='icon icon--mag-number' />
            </div>
            <div className='mag__desc'>
              <span>{t('numberShort')}</span>
              <div className='--secFont'>{number}</div>
            </div>
          </>
          : (type === 'rze01' || type === 'chr01' || type === 'box' || type === 'demo')
            ? <div className='mag__icon__label'>{t(rentableType === 'parking' ? 'parking' : `box.${type}`)} {number}</div>
            : <div className='mag__icon__label --secFont'>{t('numberShort')} {number}</div>}
      </div>

      {type === 'mm' && rentableType === 'parking' && <div className='mag__number__bottom'>
        <i className='icon icon--parkingLogo' />
      </div>}

      {isShared && <div
        className='mag__number__bottom'
        style={isDesktop ? { paddingTop: '1em' } : undefined}>
        <i className='icon icon--share' />
        {isDesktop && <span>{t('sharedBy')}: </span>}
        <span>{acronym}</span>
      </div>}
    </div>
  )
}

export default MagNumber